<template>
  <div class="system_admin">
    <!-- 管理员管理 -->
    <el-form>
      <el-row>
        <el-input
          v-model.trim="queryData.model.mobile"
          style="width: 200px; margin: 0 0 0 10px"
          placeholder="手机号"
          clearable
          @clear="clear"
        />
        <el-input
          v-model.trim="queryData.model.userName"
          style="width: 200px; margin: 0 0 0 10px"
          placeholder="用户名"
          clearable
          @clear="clear"
        />
        <el-button
          type="primary"
          class="search"
          style="margin: 0 0 0 10px"
          @click="search"
          >搜索</el-button
        >
        <el-button
          type="primary"
          class="search"
          style="margin: 0 0 0 10px"
          @click="add_click"
          >添加</el-button
        >
      </el-row>
    </el-form>

    <el-table
      class="table"
      :data="tableData"
      :header-cell-style="{ 'text-align': 'center' }"
      :cell-style="{ 'text-align': 'center' }"
      style="width: 98.5%; margin-top: 30px; margin-left: 10px"
      highlight-current-row
      @current-change="handleCurrentChangeColor"
    >
      <el-table-column prop="userName" label="用户名" width="180" />
      <el-table-column prop="country" label="国家" />
      <el-table-column prop="timezone" label="时区" />
      <el-table-column prop="roleName" label="角色" />
      <el-table-column prop="imAppName" label="项目名称" />
      <el-table-column prop="createBy" label="创建人" />
      <el-table-column prop="accountStatus" label="账号状态">
        <template slot-scope="scope">
          <el-switch
            v-if="scope.row.roleName != '管理员'"
            v-model="scope.row.accountStatus"
            active-color="#13ce66"
            inactive-color="#A4B8CF"
            active-value="1"
            inactive-value="0"
            @change="changestatus($event, scope.row, scope.$index)"
          />
          <div v-else>
            <span v-if="scope.row.accountStatus == '1'">启用</span>
            <span v-if="scope.row.accountStatus == '0'">封禁</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" />
      <el-table-column prop="createTime" label="创建时间" />
      <el-table-column label="操作" width="235">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            class="edeit"
            @click="copyClk"
            v-if="scope.row.imAppId"
             v-clipboard:copy="scope.row.imAppId"
            >复制AppId</el-button
          >
          <el-button
            type="text"
            size="small"
            class="edeit"
            @click="handlePwd(scope.row)"
            >重置密码</el-button
          >
          <el-button
            type="text"
            size="small"
            class="edeit"
            @click="handleEdit(scope.$index, scope.row)"
            >编辑</el-button
          >
          <el-button
            type="text"
            size="small"
            class="edeit"
            @click="handleDel(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="blank" />

    <!-- 分页 -->
    <el-pagination
      background
      :current-page="queryData.pageNum"
      :page-sizes="[15, 30, 50, 100, 200]"
      :page-size="queryData.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
    <!-- 添加弹框 -->
    <el-dialog :title="title" :visible.sync="adddialogFormVisible">
      <el-divider content-position="left"
        >对于管理员或角色的变更，一般需要对应的管理员重新登录才生效！</el-divider
      >
      <el-form ref="form" :model="form" label-width="100px">
        <el-form-item label="登录账号:" style="width: 92%">
          <el-input v-model="form.userName" placeholder="请输入用户名" />
        </el-form-item>

        <el-form-item label="备注:" style="width: 92%">
          <el-input v-model="form.remark" placeholder="备注" />
        </el-form-item>
        <el-form-item label="角色:">
          <el-select
            v-model="form.roleId"
            placeholder="请选择类型"
            style="width: 92%"
            @change="handleRoleChange"
          >
            <el-option
              v-for="(item, index) in roleList"
              :key="index"
              :label="item.nameZh"
              :value="`${item.id},${item.code}`"
            >
              {{ item.nameZh }}
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目名称:" style="width: 92%" v-if="isImClient">
          <el-input
            v-model="form.imAppName"
            placeholder="请输入项目名称"
          />
        </el-form-item>

        <el-form-item label="密码:" style="width: 92%" v-if="title == '添加'">
          <el-input
            v-model="form.password"
            type="password"
            placeholder="密码为6-16位字符或数字"
          />
        </el-form-item>
        <el-form-item label="国家:">
          <el-select
            v-model="form.country"
            placeholder="请选择类型"
            style="width: 92%"
            @change="handleCountryChange"
          >
            <el-option
              v-for="(item, index) in countryList"
              :key="index"
              :label="item.nameZh"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时区:" style="width: 92%">
          <el-input
            v-model="form.timezone"
            placeholder="请输入时区"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancel" @click="adddialogFormVisible = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="adddialogFormVisibleClk"
          >确 定</el-button
        >
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { post, get } from "@/utils/request";
import { getCapitalTimezoneFromCountryItem } from "@/utils/countryTimezone";

export default {
  name: "SystemManageAdminManage",

  data() {
    return {
      id: "",
      input: "",
      loading: true,
      tableData: [],
      queryData: {
        pageSize: 15,
        pageNum: 1,
        model: {
          mobile: "",
          userName: "",
        },
      },
      total: 0,
      dialogFormVisible: false,
      adddialogFormVisible: false,

      form: {
        userName: "",
        phone: "",
        roleId: "",
        roleName: "",
        remark: "",
        imAppName: "",
        country: "",
        timezone: "",
        password: "",
      },
      formLabelWidth: "25%",
      roleList: [],
      currentRow: null,
      title: "",
      countryList: [],
    };
  },
  computed: {
    isImClient() {
      if (!this.form.roleId || typeof this.form.roleId !== 'string') {
        return false;
      }
      const parts = this.form.roleId.split(',');
      return parts.length > 1 && parts[1] === 'im_client';
    },
  },
  created() {
    this.getDataList();
    this.aaa()

  },
  methods: {
    aaa(){
      post("/hub/dictionary/list", { key: 'CountryEnum' }).then((res) => {
        console.log(res.data.data,'res');
        this.countryList = res.data.data;
      });
    },
    copyClk(){
      this.$message.success("复制成功");
    },
    clear() {
      this.getDataList();
    },
    handleCurrentChangeColor(val) {
      this.currentRow = val;
    },
    handleDel(row) {
      this.$confirm("此操作将删除该用户, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        post("/admin/employee/delete", { id: row.id }).then((res) => {
          if (res.data.code != 20000) {
            this.$message({
              message: res.data.message,
              type: "error",
            });
          } else {
            this.$message({
              message: res.data.message,
              type: "success",
            });
            this.getDataList();
          }
        });
      });
    },
    handlePwd(row) {
      this.$confirm("此操作将重置该用户登录密码, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.id = row.id;
        const password = "123456";
        const id = row.id;
        post("/admin/employee/update", { password, id }).then((res) => {
          if (res.data.code != 20000) {
            this.$message({
              message: res.data.message,
              type: "error",
            });
          } else {
            this.$message({
              message: res.data.message,
              type: "success",
            });
            this.getDataList();
          }
        });
      });
    },
    handleEdit(index, row) {
      this.title = "编辑";
      console.log(row);

      this.form.id = row.id
      // 同时获取角色列表和编辑数据
      Promise.all([
        this.getRole(),
        post("/admin/employee/get", { id: row.id })
      ]).then(([roleRes, res]) => {
        this.form = res.data.data;
        // 将 roleId 转换为正确的格式以匹配 el-select 的 value
        if (this.form.roleId && this.roleList.length > 0) {
          const role = this.roleList.find(item => item.id == this.form.roleId || item.id == this.form.roleId.split(',')[0]);
          if (role) {
            this.form.roleId = `${role.id},${role.code}`;
            // 如果角色不是 im_client，清空 imAppName
            if (role.code !== 'im_client') {
              this.form.imAppName = '';
            }
          }
        }
        if (this.form.country && !this.form.timezone) {
          const row = this.countryList.find((c) => c.code === this.form.country);
          if (row) {
            this.form.timezone = getCapitalTimezoneFromCountryItem(row);
          }
        }
      });
      this.adddialogFormVisible = true;
    },
    handleCountryChange() {
      const row = this.countryList.find((c) => c.code === this.form.country);
      this.form.timezone = row
        ? getCapitalTimezoneFromCountryItem(row)
        : "";
    },
    handleRoleChange(value) {
      // 当角色改变时，判断是否为 im_client
      if (value && typeof value === 'string') {
        const parts = value.split(',');
        if (parts.length > 1 && parts[1] === 'im_client') {
          // 如果是 im_client，让用户自己填写，不清空已有值
          // 不做任何操作，保持用户已填写的内容
        } else {
          // 如果不是 im_client，清空 imAppName
          this.form.imAppName = '';
        }
      } else {
        // 如果没有选择角色，清空 imAppName
        this.form.imAppName = '';
      }
    },
    adddialogFormVisibleClk() {
      let code = this.form.roleId.split(',')[1]
      this.form.roleId = this.form.roleId.split(',')[0]
      // 如果不是 im_client，清空 imAppName
      if(code != 'im_client'){
        this.form.imAppName = ''
      }
      // 如果是 im_client，保持用户填写的值，不做任何操作
      this.adddialogFormVisible = false;
      if (this.title == "添加") {
        post("/admin/employee/add", this.form).then((res) => {
          if (res.data.code != 20000) {
            this.$message({
              message: res.data.message,
              type: "error",
            });
          } else {
            this.$message({
              message: res.data.message,
              type: "success",
            });
            this.getDataList();
          }
        });
      } else {
        post("/admin/employee/update", this.form).then((res) => {
          if (res.data.code != 20000) {
            this.$message({
              message: res.data.message,
              type: "error",
            });
          } else {
            this.$message({
              message: res.data.message,
              type: "success",
            });
            this.getDataList();
          }
        });
      }
    },
    changestatus(status, data, index) {
      post("/admin/employee/update", data).then((res) => {
        if (res.data.code != 20000) {
          this.$message({
            message: res.data.message,
            type: "error",
          });
        } else {
          this.$message({
            message: res.data.message,
            type: "success",
          });
          this.getDataList();
        }
      });
    },
    search() {
      this.getDataList();
    },
    // 获取角色信息
    getRole() {
      return post("/admin/role/page", this.queryData).then((res) => {
        this.roleList = res.data.data.data;
        return res;
      });
    },
    add_click() {
      this.title = "添加";
      this.form = {
        userName: "",
        phone: "",
        roleId: "",
        roleName: "",
        remark: "",
        imAppName: "",
        country: "",
        timezone: "",
        password: "",
      };

      this.getRole();
      this.adddialogFormVisible = true;
    },
    handleSizeChange(val) {
      this.queryData.pageSize = val;
      this.getDataList();
    },
    handleCurrentChange(val) {
      this.queryData.pageNum = val;
      this.getDataList();
    },
    getDataList() {
      post("/admin/employee/page", this.queryData).then((res) => {
        this.total = res.data.data.total;
        this.tableData = res.data.data.data;
        this.loading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
// /deep/.el-dialog {
//   width: 28%;
// }
// .rechargeFormInput {
//   width: 84%;
// }
// /deep/.el-switch__label.is-active {
//   color: #13ce66;
// }
</style>
